import { MenuItem } from "types";

export function getItem(
	label: React.ReactNode,
	key: React.Key,
	danger?: boolean,
	icon?: React.ReactNode,
	children?: MenuItem[],
	type?: "group"
): MenuItem {
	return {
		key,
		icon,
		children,
		danger,
		label,
		type,
	} as MenuItem;
}
